import { useState } from "react";
import ModalProcessing from "./ModalProcessing";

export function useModalProcessing() {
    const [show, setShow] = useState(false);

    const startProcessing = () => setShow(true);
    const stopProcessing = () => setShow(false);

    const ProcessingModalEl = <ModalProcessing show={show} />;

    return { startProcessing, stopProcessing, ProcessingModalEl };
}
